import React from "react";
import { useCustomer } from "hooks/useStore";

const LoyaltySteps = ({ data }) => {
	const { isAuthenticated } = useCustomer(["isAuthenticated"]);
	if (isAuthenticated) return null;
	return (
		<div>
			{data.title && <h2 className="text-center pb-10">{data.title}</h2>}
			<div className="flex flex-wrap lg:flex-nowrap gap-14 justify-center horizontal-padding">
				{data.steps?.map((item, index) => (
					<div key={index} className="border border-beige flex w-full max-w-lg">
						<div className="border border-l border-beige bg-cream font-header flex items-center">
							<p className="text-7xl px-12  font-header flex items-center pb-5">
								{index + 1}
							</p>
						</div>
						<div className="flex flex-col p-6 gap-2">
							{item.title && <h4>{item.title}</h4>}
							{item.text && <p className="text-secondary">{item.text}</p>}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default LoyaltySteps;